import styled from "@emotion/styled"
import { ITheme } from "./theme"

export default styled

export interface IProps {
  theme: ITheme
}
